var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attr = ref.attr;
return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.colors[_vm.type]}},'v-icon',attr,false),on),[_vm._v(" "+_vm._s(_vm.icons[_vm.type])+" ")])]}}])},[_vm._v(" "+_vm._s(_vm.labels[_vm.type])+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }